import { render } from "./SwatchGroup.vue?vue&type=template&id=1cf601b1"
import script from "./SwatchGroup.vue?vue&type=script&lang=js"
export * from "./SwatchGroup.vue?vue&type=script&lang=js"

import "./SwatchGroup.vue?vue&type=style&index=0&id=1cf601b1&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__